import type { DosageUnit } from './constants';

/** An amount with its unit as it reads in dosage text, e.g. '3 g' or '8 capsules'; the amount alone without a unit. */
export const formatWithUnit = (amount: string | number, unit?: DosageUnit) =>
  unit ? `${amount} ${unit}` : String(amount);
